import { render } from "./RecursiveSelectorElement.vue?vue&type=template&id=868962d2&ts=true"
import script from "./RecursiveSelectorElement.vue?vue&type=script&lang=ts"
export * from "./RecursiveSelectorElement.vue?vue&type=script&lang=ts"

import "./RecursiveSelectorElement.vue?vue&type=style&index=0&id=868962d2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QItemLabel,QExpansionItem,QItem});
